import React, { Component } from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { toast } from "react-toastify";
import { apiUrl } from "../../comps/apiUrl";

// Importações do Material UI Componentes
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  TextField,
  MenuItem,
  Button,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  CircularProgress,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Tooltip,
} from "@mui/material";

// Importações dos Ícones do Material UI
import {
  Search as SearchIcon,
  Refresh as RefreshIcon,
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
  PictureAsPdf as PdfIcon,
  GridOn as ExcelIcon,
  Flag as FlagIcon,
  ReceiptLong as ReceiptIcon,
  GetApp as DownloadIcon,
  Send as SendIcon,
} from "@mui/icons-material";

class Vendas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      add: false,
      dados: {},
      items: [],
      currentPage: 1,
      paginaAtual: 1,
      itemsPerPage: 100,
      totalPages: 1,
      termoPesquisa: "",
      edit: {},
      trash: {},
      busca: true,
      delmaster: {},
      viewProducts: {},
      comprovante: {},
      blockUser: {},
      filter: "1",
      equipamentos: null,
      faturamento: undefined,
      start_date: "",
      end_date: "",
      useFilter: false,
      dw: false,
      totalLc: 0,
      totalSc: 0,
      totalFn: 0,
      deleting: false,
      generatingNfId: null, // Controla o loader individual da emissão da NF
    };
    this.page = React.createRef();
  }

  Generate_token(length) {
    const a =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split(
        ""
      );
    const b = [];
    for (let i = 0; i < length; i++) {
      const j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join("");
  }

  componentDidMount() {
    document.title = "Histórico de Vendas e Notas Fiscais";
    this.LoadResults(1, 100);
  }

  handleSearch = () => {
    const { filter, start_date, end_date, faturamento } = this.state;
    this.LoadResults(
      1,
      100,
      filter,
      start_date,
      end_date,
      faturamento,
      false
    );
  };

  LoadResults = (
    page,
    l,
    filter,
    start_date,
    end_date,
    faturamento,
    busca = true
  ) => {
    this.setState({ loader: true });

    fetch(
      `${apiUrl}/sales?page=${page}&limit=${l}&filter=${filter}&start_day=${start_date}&end_day=${end_date}&busca=${faturamento}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status === 510) {
          localStorage.clear();
          window.location.href = "/";
          return;
        }

        response.json().then((data) => {
          const totalItems = data.totalItems || 0;
          const totalPages = Math.ceil(totalItems / this.state.itemsPerPage) || 1;

          this.setState({
            items: data.items || [],
            currentPage: page,
            totalLc: data.totalLc || 0,
            totalSc: data.totalSc || 0,
            totalFn: data.totalFn || 0,
            totalPages,
            busca,
            loader: false,
          });
        });
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  };

  // Método para Emitir Nota Fiscal (NFe)
  handleEmitirNfe = (vendaId) => {
    this.setState({ generatingNfId: vendaId });

    fetch(`${apiUrl}/emitir-nfe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({ venda_id: vendaId }),
    })
      .then(async (response) => {
        const resData = await response.json();
        this.setState({ generatingNfId: null });

        if (response.ok && resData.status === "autorizada") {
          toast.success("Nota Fiscal emitida com sucesso!");
          this.LoadResults(
            this.state.currentPage,
            100,
            this.state.filter,
            this.state.start_date,
            this.state.end_date,
            this.state.faturamento,
            this.state.busca
          );
        } else {
          toast.error(`Falha na emissão: ${resData.motivo || resData.error || "Erro desconhecido"}`);
        }
      })
      .catch((error) => {
        this.setState({ generatingNfId: null });
        toast.error("Erro na comunicação com o servidor: " + error.message);
      });
  };

  // Método para Baixar a DANFE em PDF
  handleDownloadDanfe = (vendaId, numeroNfe) => {
    toast.info("Gerando PDF da DANFE...");

    fetch(`${apiUrl}/vendas/danfe/${vendaId}`, {
      method: "GET",
      headers: {
        authorization: localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Erro ao baixar PDF da DANFE");
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `DANFE_NFE_${numeroNfe || vendaId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  Payment_type(t) {
    switch (t) {
      case "boletop":
        return (
          <Chip
            icon={<FlagIcon />}
            label="Boleto Pendente"
            color="error"
            size="small"
            clickable
          />
        );
      case "boletoa":
        return (
          <Chip
            icon={<FlagIcon />}
            label="Boleto Aprovado"
            color="success"
            size="small"
            clickable
          />
        );
      case "pix":
        return <Chip label="Pix" color="success" size="small" />;
      case "boleto":
        return <Chip label="Boleto" color="success" size="small" />;
      case "cartaod":
        return <Chip label="Cartão de Débito" color="success" size="small" />;
      case "cartaoc":
        return <Chip label="Cartão de Crédito" color="success" size="small" />;
      case "dinheiro":
        return <Chip label="Dinheiro" color="success" size="small" />;
      default:
        return <Chip label={t || "---"} size="small" />;
    }
  }

  // Renderização do Badge de Status da Nota Fiscal
  renderFiscalStatus(notaFiscal) {
    if (!notaFiscal) {
      return <Chip label="Não Gerada" size="small" variant="outlined" color="default" />;
    }

    if (notaFiscal.status === "autorizada") {
      return (
        <Tooltip title={`Chave: ${notaFiscal.chave_acesso}`}>
          <Chip
            icon={<ReceiptIcon />}
            label={`NFe Nº ${notaFiscal.numero_nfe}`}
            color="success"
            size="small"
          />
        </Tooltip>
      );
    }

    return (
      <Tooltip title={notaFiscal.motivo_sefaz || "Erro na emissão"}>
        <Chip
          label={notaFiscal.status || "Erro"}
          color="error"
          size="small"
        />
      </Tooltip>
    );
  }

  formatarDataBR(dataISO) {
    if (!dataISO) return "---";
    const data = new Date(dataISO);
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0");
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");
    return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
  }

  handlePageChange = (event, page) => {
    const { filter, start_date, end_date, faturamento, busca } = this.state;
    const filtro = busca === true ? "undefined" : filter;
    this.LoadResults(page, 100, filtro, start_date, end_date, faturamento);
  };

  exportToExcel = () => {
    const rentals = this.state.items;
    const excelData = [];

    rentals.forEach((rental) => {
      if (rental.products && rental.products.length > 0) {
        rental.products.forEach((product) => {
          excelData.push({
            ID: rental.id,
            Vendedor: rental.seller_name,
            Cliente: rental.client_name,
            "CPF/CNPJ": rental.client_cnpj_cpf,
            "Tipo Pagamento": rental.payment_type,
            "Valor Total": rental.location_value,
            "Nº NFe": rental.nota_fiscal ? rental.nota_fiscal.numero_nfe : "Não gerada",
            "Chave de Acesso": rental.nota_fiscal ? rental.nota_fiscal.chave_acesso : "",
            Produto: product.name,
            Quantidade: product.quantiny,
            "Data Venda": rental.start_day,
          });
        });
      }
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vendas");
    XLSX.writeFile(workbook, "vendas_e_notas.xlsx");
  };

  handleDeleteLease = () => {
    this.setState({ deleting: true });
    const id = this.state.delmaster.id;

    fetch(`${apiUrl}/delete-lease`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({ id }),
    })
      .then((response) => {
        this.setState({ deleting: false });
        if (response.status === 200) {
          toast.success("Venda removida com sucesso!");
          this.setState((prevState) => ({
            items: prevState.items.filter((item) => item.id !== id),
            delmaster: {},
          }));
        }
      })
      .catch((error) => {
        this.setState({ deleting: false });
        toast.error("Erro ao enviar dados: " + error);
      });
  };

  render() {
    if (this.state.loader) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="80vh"
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Box p={3}>
        {/* CARD DE FILTROS */}
        <Card sx={{ mb: 3 }}>
          <CardHeader
            title={<Typography variant="h6">Filtro de Vendas</Typography>}
            action={
              <Box display="flex" gap={1}>
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<ExcelIcon />}
                  onClick={this.exportToExcel}
                >
                  Excel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.busca}
                  startIcon={<RefreshIcon />}
                  onClick={() => {
                    this.LoadResults(1, 100);
                  }}
                >
                  Atualizar
                </Button>
              </Box>
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  select
                  fullWidth
                  label="Filtrar por:"
                  size="small"
                  value={this.state.filter}
                  onChange={(e) =>
                    this.setState({
                      filter: e.target.value,
                      faturamento: undefined,
                    })
                  }
                >
                  <MenuItem value="1">Cliente</MenuItem>
                  <MenuItem value="3">Data da Venda</MenuItem>
                  <MenuItem value="7">Método de Pagamento</MenuItem>
                  <MenuItem value="8">Produto</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} sm={6} md={5}>
                {this.state.filter === "7" && (
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Método de Pagamento"
                    value={this.state.faturamento || ""}
                    onChange={(e) =>
                      this.setState({ faturamento: e.target.value })
                    }
                  >
                    <MenuItem value="pix">PIX</MenuItem>
                    <MenuItem value="cartaoc">Cartão de Crédito</MenuItem>
                    <MenuItem value="cartaod">Cartão de Débito</MenuItem>
                    <MenuItem value="dinheiro">Dinheiro</MenuItem>
                    <MenuItem value="todos">Todos</MenuItem>
                  </TextField>
                )}

                {(this.state.filter === "1" || this.state.filter === "8") && (
                  <TextField
                    fullWidth
                    size="small"
                    label={this.state.filter === "1" ? "Nome do Cliente" : "Nome do Produto"}
                    onChange={(e) => {
                      if (e.target.value.length === 0) {
                        this.setState({ useFilter: false });
                      }
                      this.setState({ faturamento: e.target.value });
                    }}
                  />
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="Data Início"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) =>
                    this.setState({ start_date: e.target.value })
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="Data Fim"
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => this.setState({ end_date: e.target.value })}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={this.handleSearch}
            >
              Buscar
            </Button>
          </CardActions>
        </Card>

        {/* CARD DA TABELA DE LISTAGEM */}
        <Card>
          <CardHeader title={<Typography variant="h6">Histórico de Vendas</Typography>} />
          <Divider />
          <CardContent>
            {this.state.items.length > 0 ? (
              <>
                <Box display="flex" justifyContent="center" mb={2}>
                  <Pagination
                    count={this.state.totalPages}
                    page={this.state.currentPage}
                    onChange={this.handlePageChange}
                    color="primary"
                    showFirstButton
                    showLastButton
                  />
                </Box>

                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Cliente / Documento</strong></TableCell>
                        <TableCell><strong>Pagamento</strong></TableCell>
                        <TableCell align="center"><strong>Itens</strong></TableCell>
                        <TableCell><strong>Valor Total</strong></TableCell>
                        <TableCell><strong>Data da Venda</strong></TableCell>
                        <TableCell align="center"><strong>Status Fiscal</strong></TableCell>
                        <TableCell align="center"><strong>Ação Fiscal</strong></TableCell>
                        <TableCell align="center"><strong>Ações</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.items.map((item) => (
                        <TableRow key={item.id} hover>
                          <TableCell>
                            <Link
                              to={`/cadastro-clientes/view/${item.client_id}`}
                              style={{ textDecoration: "none", color: "#1976d2", fontWeight: "bold" }}
                            >
                              {item.client_name}
                            </Link>
                            <Typography variant="caption" display="block" color="textSecondary">
                              {item.client_cnpj_cpf || "Sem documento"}
                            </Typography>
                          </TableCell>
                          <TableCell>{this.Payment_type(item.payment_type)}</TableCell>
                          <TableCell align="center">
                            <IconButton
                              color="primary"
                              size="small"
                              onClick={() =>
                                this.setState({ equipamentos: item.products || [] })
                              }
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            {((item.location_value || 0) + (item.shipping_cost || 0)).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </TableCell>
                          <TableCell>{this.formatarDataBR(item.start_day)}</TableCell>

                          {/* COLUNA: STATUS FISCAL */}
                          <TableCell align="center">
                            {this.renderFiscalStatus(item.nota_fiscal)}
                          </TableCell>

                          {/* COLUNA: AÇÃO FISCAL */}
                          <TableCell align="center">
                            {this.state.generatingNfId === item.id ? (
                              <CircularProgress size={24} />
                            ) : item.nota_fiscal && item.nota_fiscal.status === "autorizada" ? (
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                startIcon={<DownloadIcon />}
                                onClick={() =>
                                  this.handleDownloadDanfe(item.id, item.nota_fiscal.numero_nfe)
                                }
                              >
                                DANFE (PDF)
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                color="success"
                                size="small"
                                startIcon={<SendIcon />}
                                onClick={() => this.handleEmitirNfe(item.id)}
                              >
                                Emitir NFe
                              </Button>
                            )}
                          </TableCell>

                          {/* COLUNA: AÇÕES GERAIS */}
                          <TableCell align="center">
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => this.setState({ delmaster: item })}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}

                      {/* LINHA DE TOTAIS */}
                      <TableRow sx={{ backgroundColor: "action.hover" }}>
                        <TableCell colSpan={3}>
                          <strong>Total Acumulado na Página</strong>
                        </TableCell>
                        <TableCell colSpan={5}>
                          <strong>
                            {(this.state.totalLc + this.state.totalSc).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          </strong>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box display="flex" justifyContent="center" mt={2}>
                  <Pagination
                    count={this.state.totalPages}
                    page={this.state.currentPage}
                    onChange={this.handlePageChange}
                    color="primary"
                    showFirstButton
                    showLastButton
                  />
                </Box>
              </>
            ) : (
              <Box textAlign="center" py={4}>
                <Typography variant="subtitle1" color="textSecondary">
                  Não foram encontradas vendas registradas
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>

        {/* DIALOG DE PRODUTOS/ITENS */}
        <Dialog
          open={Boolean(this.state.equipamentos)}
          onClose={() => this.setState({ equipamentos: null })}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Itens da Venda</DialogTitle>
          <DialogContent dividers>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Produto</strong></TableCell>
                    <TableCell align="right"><strong>Quantidade</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.equipamentos &&
                    this.state.equipamentos.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell align="right">{item.quantiny}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ equipamentos: null })}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE CONFIRMAÇÃO DE EXCLUSÃO */}
        <Dialog
          open={Object.keys(this.state.delmaster).length > 0}
          onClose={() => this.setState({ delmaster: {} })}
        >
          <DialogTitle>Excluir Registro de Venda?</DialogTitle>
          <DialogContent dividers>
            <Typography>
              Ao confirmar, essa venda e seu vínculo histórico serão apagados permanentemente.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.setState({ delmaster: {} })}
              disabled={this.state.deleting}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="error"
              startIcon={
                this.state.deleting ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <DeleteIcon />
                )
              }
              onClick={this.handleDeleteLease}
              disabled={this.state.deleting}
            >
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default Vendas;